import React from "react";
import StyledLgText from "../../common/components/styledLgText/StyledLgText";
import { CustomConnectButton } from "../CustomConnectButton/CustomConnectButton";
import { useAccount } from "wagmi";

const WalletNotConnected = ({ children }) => {
  // const { mutate  } = useCheckUser();
  const {isConnected: isWalletConnected } = useAccount();
  const connectButtonOnClick = () => {
    if (isWalletConnected) {
      // mutate({ wallet_address: address });
    }
  };

  return (
    <div className="w-[80%] mx-auto flex flex-col items-center justify-center gap-5 py-10 min-h-[calc(100vh-190px)]">
      <div className="w-[30vw]">
        <img src="/assets/connect-your-wallet.png" alt="Wallet Not Connected" loading="lazy"/>
      </div>
      <div>
        <CustomConnectButton onClick={connectButtonOnClick} />
      </div>
      <div className="w-1/2 flex justify-center text-center">
        <StyledLgText>{children}</StyledLgText>
      </div>
    </div>
  );
};

export default WalletNotConnected;
